import React, { Component } from 'react';
import moment from 'moment';

import api from '../../../api/api';

import Modal from "./Modal"

import DateFilter from "../../../components/ParadigmaTable/DateFilter";
import ParadigmaTable from "../../../components/ParadigmaTable/ParadigmaTable"
import NumericFilter from "../../../components/ParadigmaTable/NumericFilter"
import { format } from '../../../functions/functions';


class Monedas extends Component {
    constructor() {
        super();
    }

    render() {
        return (
            <ParadigmaTable
                buttons={[
                    {
                        create: true,
                        component: (props) => <Modal {...props} action="CREATE" />,
                        permission: 'monedas_monedas_new',
                    },
                    {
                        edit: true,
                        component: (props) => <Modal {...props} action="EDIT" />,
                        permission: 'monedas_monedas_edit',
                    },
                    {
                        edit: true,
                        component: (props) => <Modal {...props} action="DETAIL" />,
                        permission: 'monedas_monedas_detail',
                    },
                    {
                        edit: true,
                        component: (props) => <Modal {...props} action="DELETE" />,
                        permission: 'monedas_monedas_delete',
                    }
                ]}
                columns={[
                    {
                        Header: "id",
                        id: "id",
                        accessor: "id",
                        width: 100,
                        private: true,
                        show: false,
                    },
                    {
                        Header: "Última Modificación",
                        id: "modificado_en",
                        accessor: d => moment(d.modificado_en).format('DD/MM/YYYY'),
                        className: "text-center",
                        width: 100,
                        Filter: ({ filter, onChange }) => <DateFilter filter={filter} onChange={onChange} datetime />,
                        show: true,
                    },
                    {
                        Header: "Nombre",
                        id: "nombre",
                        accessor: d => d.nombre,
                        show: true,
                    },
                    {
                        Header: "Símbolo",
                        id: "simbolo",
                        accessor: d => d.simbolo,
                        show: true,
                    },
                    {
                        Header: "Cotización (Pesos Argentinos)",
                        id: "cotizacion_pesos",
                        accessor: d => '$' + format(d.cotizacion_pesos),
                        Filter: ({ filter, onChange }) => <NumericFilter filter={filter} onChange={onChange}/>,
                        show: true,
                    },
                ]}
                apiUrl={api.monedas.monedas}
                exportUrl={api.monedas.monedas}
                title={"Monedas"}
            />
        );
    }
}

export default Monedas;



// WEBPACK FOOTER //
// ./src/views/Monedas/Monedas/Monedas.js